export function tinymce() {
	const orderedListItems = document.querySelectorAll('.bold-ordered-list');
	if (orderedListItems.length > 0) {
		orderedListItems.forEach(item => {
			item.parentElement.parentElement.classList.add('bold-ordered-list');
		});
	}
}